export default __webpack_public_path__ + "de1746d9800fdf7558d9f5fec93bb20d.svg";